import AddRounded from "@mui/icons-material/AddRounded";
import DownloadRounded from "@mui/icons-material/DownloadRounded";
import MonitorHeartRounded from "@mui/icons-material/MonitorHeartRounded";

export default function HeroSection({ onDownloadAll, onAddReport }) {
  return (
    <section data-tour="dashboard-welcome" className="relative overflow-hidden rounded-2xl border border-slate-200/80 bg-gradient-to-br from-white via-slate-50/80 to-sky-50/40 p-4 shadow-[0_1px_3px_rgba(15,23,42,0.06),0_12px_40px_rgba(37,99,235,0.08)] sm:p-5 md:p-6 lg:p-8">
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-blue-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-10 h-40 w-40 rounded-full bg-emerald-500/10 blur-3xl" />

      <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex max-w-2xl gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-600 text-white shadow-lg shadow-blue-600/25">
            <MonitorHeartRounded sx={{ fontSize: 28 }} />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-blue-600">MediTrack</p>
            <h1 className="mt-1 text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl md:text-3xl">
              Personal health dashboard
            </h1>
            <p className="mt-2 text-sm leading-relaxed text-slate-600 md:text-base">
              All your medical reports, insights, and trends — organized like a modern health record you actually want to open.
            </p>
          </div>
        </div>

        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
          <button
            type="button"
            onClick={onDownloadAll}
            className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-blue-100 bg-blue-50/50 px-5 text-sm font-semibold text-blue-700 shadow-sm transition-all duration-300 hover:border-blue-200 hover:bg-blue-100/80 hover:text-blue-800 hover:shadow active:scale-[0.98] sm:w-auto"
          >
            <DownloadRounded fontSize="small" />
            Download all
          </button>
          <button
            type="button"
            onClick={onAddReport}
            data-tour="upload-btn"
            className="group relative inline-flex h-11 w-full items-center justify-center gap-2 overflow-hidden rounded-xl bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 px-6 text-sm font-bold text-white shadow-[0_4px_12px_rgba(37,99,235,0.3)] transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_6px_20px_rgba(37,99,235,0.4)] active:scale-[0.98] sm:w-auto"
          >
            <div className="absolute inset-0 bg-white/20 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            <span className="relative z-10 flex items-center gap-2">
              <AddRounded fontSize="small" />
              Add report
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
